import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from './types'
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    isSidebarOpen: true,
    isLayerselectOpen: true,
    loader: false,
    mapLoaded: false,
    mapCircleRadius: 0,
    success: false,
    currentQuestionnaireStep: 1,
    questionnaireSteps: [],
    questionnaireError: null,
    survey: {
      layers: [],
      slug: '',
      disableUserInput: false,
      disableFileUpload: false
    },
    userData: {
      selectedPlace: {
        address: {
          streetName: '',
          streetNumber: '',
          postalCode: '',
          county: '',
          town: '',
          municipality: ''
        },
        location: {
          lat: null,
          lng: null
        }
      },
      selectedLayers: [],
      userAnswers: [],
      uploadedFiles: [],
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      constent: false,
      address: {
        streetName: '',
        streetNumber: '',
        postalCode: '',
        county: '',
        town: '',
        municipality: ''
      }
    }
  },

  mutations,
  actions,
  getters
};

export default new Vuex.Store<RootState>(store);
